import axios from "../../../../../../api/axiosInstance";
import { FetchAccountMappingsResponse } from "./types";

export const fetchAccountMappings = async (
  companyUuid: string,
  signal?: AbortSignal,
): Promise<FetchAccountMappingsResponse> => {
  const response = await axios.get<FetchAccountMappingsResponse>(
    `/api/private/companies/${companyUuid}/quickbooks/account-mappings`,
    { signal },
  );
  return response.data;
};
